import React from 'react';
import GeneralInformation from './GeneralInformation';
import SubHeader from '../SubHeader';
import ListOfModels from './ListOfModels';
import NotesSection from './NotesSection';
import ReportDocumentation from './ReportDocumentation';

export default class Report extends React.Component {
  render() {
    const {id, status, description, inspectionDate, year, models, notes, documents, yearList, user,
      inspector, getDetailsLink, approvalDate, address} = this.props;

    return (
      <React.Fragment>
        <SubHeader label='Inspection Report' number='1' />
        <GeneralInformation
          user={user}
          status={status}
          description={description}
          inspectionDate={inspectionDate}
          approvalDate={approvalDate}
          year={year}
          inspector={inspector}
          address={address}
          yearList={yearList}
        />
        <ListOfModels models={models} getDetailsLink={getDetailsLink} />
        <NotesSection notes={notes} />
        <ReportDocumentation user={user} inspectionModelYear={year} documents={documents} id={id} />
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/Scenes/Inspection/Details/Report/index.jsx